import React, { Component } from "react";
import { Row } from "reactstrap";
import SearchItem from "./SearchItem";
class SearchContainer extends Component {
  componentWillMount = () => {};
  render() {
    return (
      <Row
        style={{
          height: "auto",
          minHeight: "300px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        {this.props.data.map(result => {
          return <SearchItem result={result} />;
        })}
      </Row>
    );
  }
}
export default SearchContainer;
